<template>
  <button
    v-if="$can('tickets.energyMetering') && event && !event.drawn && ticket.eligible"
    @click="checkTicket()"
    class="btn btn-fill btn-icon"
    :class="!ticket.energyMetering ? 'btn-info' : 'btn-warning'"
    :title="!ticket.energyMetering ? 'Marcar para medição' : 'Desmarcar para medição'"
  >
    <i class="ti-bolt"></i>
  </button>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'check-energy-metering-tickets',

    props: {
      ticket: {
        type: Object,
        required: true
      }
    },

    computed: {
      events: {
        get () {
          return this.$store.state.events.all.reduce((acc, curr, indx) => {
            if (indx === 0) {
              acc = {}
            }
            acc[curr._id] = curr
            return acc
          }, {})
        }
      },

      event () {
        return this.events[this.ticket.eventId] ? this.events[this.ticket.eventId] : this.$store.state.events.one
      }
    },

    methods: {
      ...mapActions('tickets', ['upsertWithView']),

      checkTicket () {
        let win = {energyMetering: !this.ticket.energyMetering}
        if (!this.ticket.winner) {
          win.winner = (!this.event.hasOwnProperty('energyDefaultWinner') || this.event.energyDefaultWinner) ? !this.ticket.energyMetering : false
        }
        const doc = Object.assign({}, this.ticket, win)
        this.upsertWithView({
          find: {
            ddoc: 'tickets-by-id',
            view: 'tickets-by-id',
            key: doc._id
          },
          payload: doc
        })
          .then(() => {
            this.$notify({
              message: 'Ticket marcado para medição.',
              type: 'success'
            })
            this.$emit('changeTickets')
          })
          .catch(err => {
            console.log(err)
            this.$notify({
              message: 'Ocorreu um problema ao definir o cliente para medição.',
              type: 'error'
            })
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/CheckEnergyMeteringTickets.vue